<template>
  <div>
    <custom-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :productType="productType"
      :titleObj="titleObj"
    >
    </custom-header>
    <h2>FA融资服务</h2>
    <div class="bg_yellow"></div>
    <p>
      一匠推出FA融资服务，立足于产业，提供产业链价值资源，全方位帮助创业公司实现高速成长的重要一步，<br />
      一匠将会在资源服务的基础上，帮助客户找到靠谱的投资人，为客户提供全方位，高效，专业的一站式融资服务。
    </p>
    <div class="service">
      <div
        :class="['service_item', serviceIndex == 0 ? 'mb-10' : '']"
        @mouseenter="change(0)"
        @mouseleave="zero"
      >
        <img src="../../static/images/FAfinancing/yiduiy.png" alt="" />
        <p>
          一对一融资辅导<br />
          制定融资策略
        </p>
      </div>
      <div
        :class="['service_item', serviceIndex == 1 ? 'mb-10' : '']"
        @mouseenter="change(1)"
        @mouseleave="zero"
      >
        <img src="../../static/images/FAfinancing/shangyejiegou.png" alt="" />
        <p>
          梳理商业结构<br />
          提供有价值真实信息
        </p>
      </div>
      <div
        :class="['service_item', serviceIndex == 2 ? 'mb-10' : '']"
        @mouseenter="change(2)"
        @mouseleave="zero"
      >
        <img src="../../static/images/FAfinancing/yuejian.png" alt="" />
        <p>
          约见一流投资机构<br />
          打造高效创投桥梁
        </p>
      </div>
      <div
        :class="['service_item', serviceIndex == 3 ? 'mb-10' : '']"
        @mouseenter="change(3)"
        @mouseleave="zero"
      >
        <img src="../../static/images/FAfinancing/changyeziyuan.png" alt="" />
        <p>
          提供产业资源<br />
          深挖产业服务
        </p>
      </div>
    </div>

    <h2>服务流程</h2>
    <div class="bg_yellow"></div>
    <p>融资流程，一站式完成</p>
    <div class="servicc_flow">
      <div
        :class="['servicc_flow_item', serviceIndex == 4 ? 'mt-10' : '']"
        @mouseenter="change(4)"
        @mouseleave="zero"
      >
        <img src="../../static/images/FAfinancing/shaixuan.png" />
        <h4>项目筛选</h4>
        <p>
          项目沟通、需求评估、<br />
          合作方案确定、项目需求调研
        </p>
        <!-- 		<div class="circle">
						<span class="circle_yellow">1</span>
					</div> -->
      </div>
      <div
        :class="['servicc_flow_item mt-60', serviceIndex == 5 ? 'mt-10' : '']"
        @mouseenter="change(5)"
        @mouseleave="zero"
      >
        <img src="../../static/images/FAfinancing/qiatan.png" />
        <h4>商务洽谈</h4>
        <p>
          技术开发范围确定、<br />
          股份和费用确定、合作协议签订
        </p>
        <!-- 				<div class="circle">
						<span class="circle_yellow">2</span>
					</div> -->
      </div>
      <div
        :class="['servicc_flow_item', serviceIndex == 6 ? 'mt-10' : '']"
        @mouseenter="change(6)"
        @mouseleave="zero"
      >
        <img src="../../static/images/FAfinancing/pinggu.png" />
        <h4>项目价值评估</h4>
        <p>
          项目盈利评估、<br />
          项目风险评定、项目价值评估
        </p>
        <!-- 				<div class="circle">
						<span class="circle_yellow">3</span>
					</div> -->
      </div>
      <div
        :class="['servicc_flow_item mt-60', serviceIndex == 7 ? 'mt-10' : '']"
        @mouseenter="change(7)"
        @mouseleave="zero"
      >
        <img src="../../static/images/FAfinancing/jiankong.png" />
        <h4>项目监控</h4>
        <p>研发过程透明监控、研发进度 在线跟踪、产品质量在线跟踪</p>
        <!-- 			<div class="circle">
					<span class="circle_yellow">4</span>
				</div> -->
      </div>
      <div
        :class="['servicc_flow_item', serviceIndex == 8 ? 'mt-10' : '']"
        @mouseenter="change(8)"
        @mouseleave="zero"
      >
        <img src="../../static/images/FAfinancing/fuwu.png" />
        <h4>持续服务</h4>
        <p>
          开发版本迭代、技术咨询、<br />
          技术人员招募、系统运维
        </p>
        <!-- 		<div class="circle">
						<span class="circle_yellow">5</span>
					</div> -->
      </div>
    </div>
    <div class="servicc_flow_timer">
      <div class="box align-top">
        <div class="circle">
          <span class="circle_yellow">1</span>
        </div>
      </div>

      <div class="box align-bottom">
        <div class="circle">
          <span class="circle_yellow">2</span>
        </div>
      </div>
      <div class="box align-top">
        <div class="circle">
          <span class="circle_yellow">3</span>
        </div>
      </div>
      <div class="box align-bottom">
        <div class="circle">
          <span class="circle_yellow">4</span>
        </div>
      </div>
      <div class="box align-top">
        <div class="circle">
          <span class="circle_yellow">5</span>
        </div>
      </div>
    </div>
    <h2>合作机构</h2>
    <div class="bg_yellow"></div>
    <p>对接一流投资机构，提供专业融资服务</p>
    <div class="qiye">
      <div class="qiye_item">
        <img
          :src="item.pc_image"
          class="img"
          v-for="(item, index) in qiyeList"
          :key="index"
        />
      </div>

      <!-- <img :src="'../../static/images/FAfinancing/'+index+'.png'"  v-for="(item,index) in 24" :key="index"> -->
    </div>
    <div class="butom_box">
      <div class="p">让营销从此变得多姿多彩，现在咨询更多优惠!</div>
      <span class="click_botton" @click="jumpService">立即咨询</span>
    </div>
    <home-footer
      :bottom="bottom"
      :bottomInfo="bottomInfo"
      :bottomNews="bottomNews"
      :productType="productType"
    >
    </home-footer>
  </div>
</template>

<script>
import CustomHeader from "@/components/pc/Header";
import HomeFooter from "@/components/pc/Footer";
export default {
  components: {
    CustomHeader,
    HomeFooter,
  },
  data() {
    return {
      actIndex: 2,
      imgList: [],
      logo: "",
      productType: [],
      titleObj: {},
      topStyle: "",
      serviceIndex: -1,
      qiyeList: [],
      bottom: {},
      bottomInfo: {},
      bottomNews: [],
      productType: [],
    };
  },
  mounted() {
    this.Pc_Mobile();
    this.getPageData();
    this.getHeaderImage();
    this.titleObj = {
      title: "FA融资",
      desc: "一匠为企业提供不同维度、不同阶段的股权融资资源，精准对接，提供针对PEVC基金、产业资本基金、并购重组等的专业FA服务。 ",
    };
    // for(let i = 1; i<25;i++){
    // 	let img = require('../../static/images/FAfinancing/'+i+'.png');
    // 	this.qiyeList.push(img);

    // }
    this.getInstitutionsList();
  },
  methods: {
    getInstitutionsList() {
      //获取合作机构
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/cooperativeagency",
        null,
        (res) => {
          // console.log(res)
          this.qiyeList = res.data;
        }
      );
    },
    //立即咨询
    jumpService() {
      this.$addConsult()
    },
    change(index) {
      this.serviceIndex = index;
    },
    zero() {
      this.serviceIndex = -1;
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_FaFinancing");
      } else {
        this.$router.push("/FAfinancing");
      }
    },
    getPageData() {
      this.$http.post("home/index/product", null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0];
        this.logo = this.bottom.logo;
        // this.topStyle = "background-image:url('" + this.background + "')";
        this.bottomInfo = res.data.contact[0];
        this.productType = res.data.type;
        this.productAll = res.data.product;
        this.bottomNews = res.data.b_news;
      });
    },
    getHeaderImage() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/special",
        {
          type_two: 2,
        },
        (res) => {
          // console.log(res, "qwuioiquwe");
          if (res.code == 1) {
            this.topStyle = "background-image:url('" + res.data.pc_image + "')";
          }
          // console.log(res.data, 'qwuioiquwe')
        }
      );
    },
    // getPageData() {
    //   this.$http.post("home/index/homeinfo", null, (res) => {
    //     // console.log(res.data)
    //     this.bottom = res.data.bottom[0];
    //     this.logo = this.bottom.logo;
    //     // this.imgList = res.data.banner;

    //     this.about = res.data.company[0];
    //     this.bottomInfo = res.data.contact[0];
    //     // this.partner = res.data.partner;
    //     this.business = res.data.work;
    //     this.advantage = res.data.software;
    //     this.develop = res.data.flow;
    //     this.productType = res.data.type;
    //     this.bottomNews = res.data.b_news;
    //     this.showHeader = true;
    //     this.$nextTick(() => {
    //       this.$refs.bannerRef.imgSwiper();
    //     });
    //   });
    // },
  },
};
</script>

<style lang="stylus" scoped>
h2 {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin-top: 100px;
  text-align: center;
}

p {
  max-width: 845px;
  margin: 0 auto;
  margin-top: 30px;
  text-align: center;
  line-height: 20px;
}

.bg_yellow {
  margin-top: 15px;
  margin: 0 auto;
  width: 42px;
  height: 2px;
  background: #F5BA1A;
  border-radius: 1px;
  text-align: center;
}

.service {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 248px;
  margin-top: 49px;

  .mb-10 {
    margin-bottom: 10px !important;
  }

  .service_item {
    width: 332px;
    height: 238px;
    background: #FFFFFF;
    box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
    border-radius: 4px;
    margin: 0 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: all 0.3s;

    img {
      width: 80px;
      height: 64px;
    }

    p {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
    }
  }
}

.servicc_flow {
  box-sizing: border-box;
  width: 1400px;
  height: 386px;
  padding: 0 30px;
  margin: 0 auto;
  margin-top: 49px;
  display: flex;
  position: relative;
  justify-content: space-between;

  .mt-10 {
    top: -10px;
    transition: all .5s;
  }

  .servicc_flow_item {
    box-sizing: border-box;
    width: 236px;
    height: 306px;
    background: url('../../static/images/FAfinancing/bg.png');
    // margin: 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
    position: relative;

    img {
      height: 84px;
      width: 84px;
      margin-top: 48px;
    }

    h4 {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      margin-top: 25px;
    }

    p {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-top: 19px;
    }
  }

  .mt-60 {
    margin-top: 70px;
  }
}

.servicc_flow_timer {
  width: 1400px;
  height: 70px;
  margin: 0 auto;
  margin-bottom: 18px;
  // margin-top:26px;
  background: url('../../static/images/FAfinancing/bolangxian.png');
  background-size: contain;
  padding: 0 30px;
  display: flex;
  justify-content: space-between;

  .align-top {
    align-self: flex-start;
    position: relative;
    top: -17px;
  }

  .align-bottom {
    align-self: flex-end;
    position: relative;
    bottom: -17px;
  }

  .box {
    width: 236px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .circle {
    // position absolute;
    // left:96px;
    // bottom:-95px;
    height: 42px;
    width: 42px;
    border: 1px solid #CCCCCC;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    .circle_yellow {
      height: 30px;
      width: 30px;
      background: #FFC000;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
  }
}

.qiye {
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 49px;
  margin-bottom: 160px;
  height: 544px;
  width: 1329px;
  padding: 0 12px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .qiye_item {
    background: #FFFFFF;
  }

  .img {
    width: 213px;
    height: 136px;
  }
}

.butom_box {
  height: 160px;
  box-sizing: border-box;
  background: url('../../static/images/FAfinancing/buttom_bg.png') no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .p {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
  }

  .click_botton {
    display: block;
    cursor: pointer;
    margin: 0 auto;
    margin-top: 25px;
    width: 170px;
    height: 50px;
    border: 1px solid #FFFFFF;
    border-radius: 4px;
    text-align: center;
    line-height: 50px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/FAfinancing.vue